import {Component} from "react"
import AccountPanel from "src/components/login/AccountPanel"
import ApiHandler from "src/api/ApiHandler";
import EventAdaptingStateHandler from "src/states/EventAdaptingStateHandler";
import LoginHelper from "src/components/login/LoginHelper";
import StateConstants from "src/states/StateContstants";
import navigationService from "src/navigation/NavigationService";

// Auth Button Component
class AuthButton extends Component<any, {isLoggedIn: boolean, showAccountPanel: boolean}> {
    private apiHandler: ApiHandler;
    private stateHandler: EventAdaptingStateHandler;
    private loginHelper: LoginHelper;

    constructor(props: any) {
        super(props);
        this.state = { isLoggedIn: false, showAccountPanel: false };
        this.apiHandler = props.apiHandler;
        this.stateHandler = props.stateHandler;
        this.loginHelper = props.loginHelper;
        this.stateHandler.addListener("isLoggedIn", (isLoggedIn: boolean) => {
            this.setState({ isLoggedIn: isLoggedIn });
        });
        this.stateHandler.addListener("showAccountPanel", (showAccountPanel: boolean) => {
            this.setState({ showAccountPanel: showAccountPanel });
        });
        this.stateHandler.addListener(StateConstants.USER_FEATURES, () => {
            this.setState({});
        });
        this.stateHandler.addListener(StateConstants.IS_PREMIUM, () => {
            this.setState({});
        });
    }

    async componentDidMount() {
        await this.checkAuthStatus();
    }

    async checkAuthStatus() {
        const token = await this.loginHelper.isLoggedIn();
        this.stateHandler.set("isLoggedIn", token);
        if (token) {
            await this.fetchPremiumStatus();
        }
    }

    async fetchPremiumStatus() {
        try {
            const userInfo = await this.apiHandler.getUserInfo();
            const features: string[] = userInfo?.features || [];
            this.stateHandler.set(StateConstants.USER_FEATURES, features);
            this.stateHandler.set(StateConstants.ACCOUNT_TYPE, userInfo?.at || "basic");
            this.stateHandler.set(StateConstants.IS_PREMIUM, features.length > 0);
        } catch (error) {
            // Non-critical — default to no features
            this.stateHandler.set(StateConstants.USER_FEATURES, []);
            this.stateHandler.set(StateConstants.IS_PREMIUM, false);
        }
    }

    handleAuthAction() {
        if (this.stateHandler.get("isLoggedIn")) {
            this.stateHandler.set("showAccountPanel", true);
        } else {
            this.stateHandler.set(StateConstants.SHOW_LOGIN_MODAL, true);
        }
    }

    closeAccountPanel() {
        this.stateHandler.set("showAccountPanel", false);
    }

    render() {
        const isLoggedIn = this.stateHandler.get("isLoggedIn");
        const isPremium = this.stateHandler.get(StateConstants.IS_PREMIUM);
        const featuresLoaded = this.stateHandler.get(StateConstants.USER_FEATURES) !== undefined && this.stateHandler.get(StateConstants.USER_FEATURES) !== null;

        return (
            <>
                <div className="auth-button-wrapper">
                    <button
                        className={`login-signup-button${isLoggedIn ? " login-signup-button-logged-in" : ""}`}
                        onClick={() => this.handleAuthAction()}
                    >
                        {isLoggedIn ? (
                            <img src="/homeindex_logo.svg" alt="Account" style={{width: 18, height: 18}} />
                        ) : 'Login'}
                    </button>
                    {isLoggedIn && featuresLoaded ? (
                        <span className={isPremium ? "tier-label tier-label-lifetime" : "tier-label tier-label-free"}>
                            {isPremium ? "LIFETIME" : "FREE"}
                        </span>
                    ) : !isLoggedIn ? (
                        <span className="tier-label tier-label-free">FREE</span>
                    ) : null}
                </div>
                
                <AccountPanel
                    isOpen={this.stateHandler.get("showAccountPanel")}
                    onClose={() => this.closeAccountPanel()}
                    apiHandler={this.apiHandler}
                    loginHelper={this.loginHelper}
                    stateHandler={this.stateHandler}
                />
            </>
        );
    }
}

export default AuthButton
